import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'
import logo from '../../images/little-logo.png'

export const Nav = styled.nav`
  background: ${({scrollNav}) => (scrollNav ? '#ffffff' : 'transparent')};
  height: 80px;
  margin-top: -80px;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  // top:0;
  z-index:10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 90px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`
export const NavLogo = styled(LinkR) `
  color:#fff;
  justify-self: flex-start;
  width: 162px;
  height: 48px;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-top: 17px;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
  background: url(${logo}) center no-repeat;
  
`
export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #000;
    // background: 
  }
`

export const NavMenu = styled.ul`
  display:flex;
  justify-content: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`
export const NavItem = styled.li`
  height: 70px;
`
export const NavLinks = styled(LinkS)`
color: #000000;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  &:hover {
    transition: all 0.2s ease-in-out;
    font-size: 18px;
    // background: #4cc2c0;
    // color: #fff;
    // border-top-left-radius: 25px;
    
    
  }
  &.active {
    border-bottom: 3px solid #01bf71;
    color: #3cb878;
  }
`
export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 400px) {
    display: none;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const NavBtnLink = styled.div`
  border-radius: 50px;
  background: #6c6ff2;
  white-space: nowrap;
  padding: 10px 14px;
  font-weight: 300;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 1s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #3cb878;
    color: #fff;
  }
`

export const NavBtnLinkSacco = styled.div`
  border-radius: 50px;
  background: #000000;
  white-space: nowrap;
  padding: 10px 14px;
  font-weight: 300;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 1s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #6c6ff2;
    color: #fff;
  }
`

export const subMenuList = styled.div`
display: none;
position: absolute;
background-color: #f9f9f9;
min-width: 160px;
box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
padding: 12px 16px;
z-index: 1;
`

export const subMenu = styled.div`
    position: relative;
    display: inline-block;

    &:hover ${subMenuList} {
      display: block;
    }

`


